import { createResourceReducer } from '../@common/reducers/resource-reducer';
import { GROUPS_PREFIX } from './constants';

export const groupsReducer = createResourceReducer(GROUPS_PREFIX);
